export function createReturnPath(returnTo: string, token?: string) {
  return token ? `/t/${token}${returnTo}` : returnTo;
}
